// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8c52e5e9","833":"8d2f3316"}[chunkId] + ".chunk.js";
};